module.exports = __webpack_public_path__ + "static/media/login.8a18ec8a.jpeg";